const NameSpaces = {
  COMMON: 'common',
  AUTH: 'auth',
  VALIDATIONS: 'validations',
  OB: 'ob',
  PAYWALL: 'paywall',
  download: 'download',
  stripe: 'stripe',
  landing: 'landing',
  PP: 'pp',
  CHAT: 'chat',
};

export default Object.values(NameSpaces);
export { NameSpaces };
